module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAMAAAC9M9RRAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA8UExURbzU7rzV7rvV7rvV7rzV7rzU7bvV7UxpcbzU7r3U7bvV7rzV6rvU77vV7rvU7rzV77vW7rvV7bvV7rzV7gCTsYMAAAATdFJOU7Ht4cXUKNwA9xw7DEKNeDJfU6m6OLRoAAAAqUlEQVQoz6XSSRKEIAwF0EQCAYFWzP3v2gwuGFo3/TdUvV8WGICDZIhxXAIk0MXgXYAAd4Ht04rFuRWrt2LyK3stJo+yt2Jyh7LloEzOLtbjLn5v37vX4YxANLpTKIIGlB1dSwzaM6fZra7rufjx4Purp18elCJcPU8hn7VzfZHJEwvlIvv/UgV29nGzFDov39tyfd75fj5JIaWnuf3n47u6IwTzO6yh4wvHmxS0nBoOIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/mp3_icon.png
// module id = ORMZ
// module chunks = 38